import { useEffect } from "react";
import Actions from "./Actions";
import { HaasSection, TAB_KEYS } from "./HaasSection";
import { useSelector } from "react-redux";

import { Fragment, useState } from "react";
import FormContentCard from "../../../Components/PageFormComponents/FormContentCard";
import { SelfHostedFields } from "./SelfHostedFields";
import { useHaasSelector } from "../../../Services/Redux/selectors/aiServiceDetailsSelector";

const PricingDistribution = () => {
    const serviceDetails = useSelector((state) => state.aiServiceDetails);

    const [isHaasSectionActivated, setIsHaasSectionActivated] = useState(false);
    const [currentHaasSectionTab, setCurrentHaasSectionTab] = useState(TAB_KEYS.daemonAI); // keyof typeof TAB_KEYS

    const { hasDaemon: hasHaasDaemon, hasService: hasHaasService } = useHaasSelector();

    const isSelfHostedFieldsFreezed =
        isHaasSectionActivated &&
        ((currentHaasSectionTab === TAB_KEYS.daemon && !hasHaasDaemon) ||
            (currentHaasSectionTab === TAB_KEYS.daemonAI && !hasHaasService));

    /**
     * When the daemon and/or daemon+ai are initialized, the Haas window cannot be closed. If initialization has not yet completed (For the daemon+ai tab, initialization can be performed after initialization in the daemon tab), all fields are locked. After initialization, only some fields are locked. The default tab is the daemon+ai tab. Therefore, if only the daemon is initialized, the Haas window cannot be closed, the daemon+ai tab remains the default tab, and all fields are locked. Therefore, when initializing only the daemon, we must switch from the default tab to the daemon.
     */
    function changeDefaultTabToDaemonIfNecessary(hasHaasDaemon, hasHaasService) {
        if (hasHaasDaemon && !hasHaasService) {
            setCurrentHaasSectionTab(TAB_KEYS.daemon);
        }
    }
    useEffect(() => {
        changeDefaultTabToDaemonIfNecessary(hasHaasDaemon, hasHaasService);
    }, [hasHaasDaemon, hasHaasService]);

    return (
        <Fragment>
            <FormContentCard title="Pricing & Distribution">
                <HaasSection
                    isActivated={isHaasSectionActivated}
                    setIsActivated={setIsHaasSectionActivated}
                    currentHaasSectionTab={currentHaasSectionTab}
                    setCurrentHaasSectionTab={setCurrentHaasSectionTab}
                />
                <SelfHostedFields
                    isFreezedByActivatedHaas={isSelfHostedFieldsFreezed}
                    isHaasDaemonInitiated={hasHaasDaemon}
                    isHaasDaemonAIInitiated={hasHaasService}
                />
            </FormContentCard>
            <Actions serviceDetails={serviceDetails} />
        </Fragment>
    );
};

export default PricingDistribution;
